import { render, staticRenderFns } from "./notificationList.vue?vue&type=template&id=e47a085c&"
import script from "./notificationList.vue?vue&type=script&lang=js&"
export * from "./notificationList.vue?vue&type=script&lang=js&"
import style0 from "./notificationList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports